/* WanderS: hover-to-open for desktop header dropdowns.
   - Mouse + desktop only (hover:hover, pointer:fine, >=990px). Touch, tablet
     drawer and keyboard keep Dawn's native click/Enter/Escape behaviour.
   - Uses details.open, so Dawn's header-menu 'toggle' handling, aria-expanded
     and focus-out closing still run.
   - Bound once per <details>; global guard prevents duplicate listeners. */
(function () {
  if (window.__wandersHeaderHover) return;
  window.__wandersHeaderHover = true;

  var mq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  var SELECTOR = '.header__inline-menu header-menu > details, .header__inline-menu details-disclosure > details';
  var CLOSE_DELAY = 220;

  function closeOthers(current) {
    document.querySelectorAll(SELECTOR).forEach(function (d) {
      if (d !== current && d.open) {
        d.open = false;
        delete d.dataset.wmHoverOpened;
      }
    });
  }

  function bind(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (details) {
      if (details.dataset.wmHoverBound === 'true') return;
      details.dataset.wmHoverBound = 'true';

      var summary = details.querySelector(':scope > summary');
      var timer = null;

      details.addEventListener('mouseenter', function () {
        if (!mq.matches) return;
        clearTimeout(timer);
        if (!details.open) {
          closeOthers(details);
          details.open = true;
          details.dataset.wmHoverOpened = 'true';
        }
      });

      details.addEventListener('mouseleave', function () {
        if (!mq.matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () {
          var active = document.activeElement;
          var focusInsidePanel = active && active !== summary && details.contains(active);
          if (!focusInsidePanel) {
            details.open = false;
            delete details.dataset.wmHoverOpened;
          }
        }, CLOSE_DELAY);
      });

      if (summary) {
        // A click right after a hover-open should keep the panel open, not toggle it shut.
        summary.addEventListener('click', function (event) {
          if (details.dataset.wmHoverOpened === 'true' && details.open) {
            event.preventDefault();
            delete details.dataset.wmHoverOpened;
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else {
    bind(document);
  }

  document.addEventListener('shopify:section:load', function (event) { bind(event.target); });
})();
